import { render } from "./searchNextPrevious.vue?vue&type=template&id=61a4385e"
import script from "./searchNextPrevious.vue?vue&type=script&lang=js"
export * from "./searchNextPrevious.vue?vue&type=script&lang=js"

import "./searchNextPrevious.vue?vue&type=style&index=0&id=61a4385e&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__